/** 
 * Fetch wrapper for making API calls. 
 * It is primarily used by the store, but can be used generically in other components.
 * @param {string} jwt most API calls will require it
 * @param {object} fetchOptions
 * @param {string} fetchOptions.method GET, POST, PUT, DELETE
 * @param {string} fetchOptions.url
 * @param {object} fetchOptions.parms query parameter key/values
 * @param {object} fetchOptions.body the body (typically a JSON object)
 * @param {object} fetchOptions.headers any headers you wish to include
 */
let doFetch = async function(jwt, fetchOptions){
  let {method, url, parms, body, headers} = fetchOptions;

  url = process.env.VUE_APP_API_BASE_URL + url;

  if (parms) {
    let searchParams = new URLSearchParams();
    for (let key in parms) {
      searchParams.append(key, parms[key]);
    }
    let search = searchParams.toString();
    if (search) url += "?" + search;
  }
  
  let data = {};
  try {
    let options = {
      method,
      // mode: 'cors',
      headers: {
        "Content-Type": "application/json"
      },
    };
    if (jwt) {
      options.headers.set("Authorization", `Bearer ${jwt}`);
    }
    if(headers){
      //Override headers with anything explicitly provided.
      Object.assign(options.headers, headers);
    }
    if (method === "POST" || method === "PUT") {
      if (body) {
        options.body = JSON.stringify(body);
      }
    }
    let response = await fetch(url, options);
    if ([401, 403].indexOf(response.status) >= 0) {
      throw new ApiAuthorizationError("Unauthorized.", response.status);
    } else if (response.status >= 400 && response.status < 500) {
      data = await response.json();
      throw new ApiError(data.message||data.error||"Data error.", response.status, data);
    } else if (response.status >= 500) {
      //throw these.
      data = await response.json();
      throw new ApiError(data.message||data.error||"Server error.", response.status, data);
    } else if (response.ok) {
      data = await response.json();
    }
    return data;
  } catch (ex) {
    if (ex instanceof ApiError) throw ex;
    if (ex instanceof TypeError) {
      if(ex.message && ex.message.toLowerCase().includes("failed to fetch")||ex.message.includes("net::ERR")){
        throw new ApiNotAvailableError("Unable to reach server. Please check your network connection.");
      }
    }
    console.error(ex);
    console.error(`${method} ${url} error. ${ex.message}`);
    throw new ApiError(ex.message);
  } 
}
export {doFetch};


export class ApiError extends Error {
  constructor(msg, status, data){
    super(msg);
    this.status = status;
    this.data = data;
  }
}

export class ApiAuthorizationError extends ApiError {}
export class ApiNotAvailableError extends ApiError {}